import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Fort Myers, FL?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Fort Myers can take 2–6 months, especially during busy travel seasons. For spring training visitors, families planning Caribbean cruises, and retirees with upcoming eco-tours, that timeline is simply not viable.",
  },
  {
    q: "Can Cape Coral residents use Fast Passport Center?",
    a: "Absolutely. Cape Coral is one of our most served communities in Lee County. Whether you need a renewal before a spring break cruise, a first-time passport for a Costa Rica eco-tour, or an emergency replacement before a Canadian fishing trip, we serve Cape Coral with the same expedited processing as Fort Myers. Start online, ship overnight, and we handle the rest.",
  },
  {
    q: "What if my passport expires before a Caribbean cruise?",
    a: "This happens more often than you would think, especially in a cruise-heavy market like Fort Myers. Most cruise lines require your passport to be valid for at least six months beyond your return date. If your expiration is cutting it close, we strongly recommend expedited processing. Standard mail-in renewal through a Fort Myers post office typically takes 2–6 months — far too long for an upcoming sailing from Fort Lauderdale, Miami, or Tampa.",
  },
  {
    q: "Can I renew my passport fast before a spring training road trip?",
    a: "Yes. Whether you are a Red Sox or Twins fan heading to Toronto or Montreal after spring training in Fort Myers, or a snowbird flying back north for the season, we can process your renewal in as little as 2–9 business days depending on the service level you choose. Many Fort Myers residents book these trips on relatively short notice during the excitement of spring training season — our expedited service is designed for exactly that scenario.",
  },
  {
    q: "How quickly can Sanibel or Captiva travelers receive an expedited passport?",
    a: "Sanibel and Captiva travelers have the same access to our expedited services as Fort Myers residents. Since we operate remotely, your physical location on the islands does not affect processing speed. Ship your documents overnight from Sanibel or Captiva, or use courier pickup if available, and we handle the rest. Most island clients receive their passports within 2–9 business days.",
  },
  {
    q: "Can families with multiple children expedite passports together?",
    a: "Yes — families are a significant portion of our Fort Myers client base. We regularly handle multiple child passport applications simultaneously, which is common for spring break cruises and summer eco-tours. Each child requires parental consent and an in-person acceptance step, but we provide clear instructions for each family member so the process stays organized and on schedule.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Fort Myers travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Fort Myers, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Fort Myers, Cape Coral, or Sanibel area.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function FortMyersFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Fort Myers and Lee County travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}